import React, { useEffect } from 'react'
import './index.scss'
import Header from '@shared/Header'
import Footer from '@shared/Footer'
import { Container } from 'react-bootstrap'
import ServicesOne from '@assets/images/services-one.jpg'
import ServiceArrowLeft from '@assets/images/left-down-arrow.png'
import ServiceArrowRight from '@assets/images/right-top.png'
import ServicesBgArrow from '@assets/images/services-bg-arrow.png'
import AccordionOne from '@assets/images/accordion-1.jpg'

const AboutUs = () => {
  const [activeAccordion, setActiveAccordion] = React.useState('1')
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <Header />
      <div className='about-us'>
        <Container>
          <div className='pt-5'>
            <h1 className='services-title'>
              Connecting Experts, Delivering Solutions
            </h1>
          </div>
          <div className='services-content'>

            <div className='services-content-item'>
              <div className='services-content-item__two'>
                <div className='services-content-item__two-content one'>
                  <h5>Expertise on Demand</h5>
                  <p>
                    Access a vast network of
                    professionals across industries for
                    tailored solutions to meet your
                    unique needs.
                  </p>
                </div>
                <div
                  className='services-content-item__two-content two'
                  style={{ backgroundImage: `url(${ServiceArrowLeft})` }}
                >
                  <h5>Flexible Engagements</h5>
                  <p>
                    Choose from diverse engagement
                    options, from quick consultations to
                    long-term collaborations.
                  </p>
                </div>
                <div
                  className='services-content-item__two-content three'
                  style={{ backgroundImage: `url(${ServiceArrowRight})` }}
                >
                  <h5>Advanced Skillsets</h5>
                  <p>
                    Discover experts proficient in
                    trending technologies like AI, ML,
                    Blockchain, and more.
                  </p>
                </div>
                <div className='services-content-item__two-content four'>
                  <h5>Empowering Growth</h5>
                  <p>
                    Enabling clients and experts to
                    collaborate effectively, drive
                    innovation, and achieve lasting
                    success.
                  </p>
                </div>
              </div>
            </div>
            <div className='services-content-item'>
              <div
                className='services-content-item__one'
                style={{ backgroundImage: `url(${ServicesOne})` }}
              >
                {/* <h3>Enabling experts on call</h3> */}
                <p>
                  ExpertBunch is a dynamic platform
                  designed to bring together skilled
                  professionals and clients in need
                  of expert solutions. Leveraging
                  advanced technologies like AI and
                  ML, we make it easy to find,
                  connect, and collaborate with
                  industry leaders across a range of
                  fields. With flexible engagement
                  options and a focus on innovation,
                  ExpertBunch empowers
                  businesses and experts alike to
                  achieve their goals effectively.
                </p>
                {/* <img src={ServicesOne} alt='' /> */}
              </div>
            </div>
            <div className='services-content-item'>
              <div className='services-content-item__three'>
                <img src={AccordionOne} />
              </div>
            </div>
            <div className='services-content-item'>
              <div className='services-content-item__four'>
                <div className='about-company'>
                  <h5>About the company</h5>
                  <p style={{ textAlign: 'justify', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
                    <strong>IBIZ Technova Inc.</strong> is a U.S.-based IT services and consulting firm. The company specializes in delivering advanced digital transformation solutions, focusing on technologies such as <strong>Artificial Intelligence (AI)</strong>, <strong>Machine Learning (ML)</strong>, <strong>SAP Business Technology Platform (BTP)</strong>, <strong>S/4HANA</strong>,  <strong>Internet of Things (IoT)</strong>, and <strong>Industry 5.0</strong> innovations.<br /><br />

                    <strong>🏆 Notable Achievements</strong><br />
                    Developed and delivered SaaS-based solutions on <strong>SAP BTP</strong>, recognized by several organizations including EUISSCA SSCA (USA).<br />
                    <br></br>
                    <strong>📈 Mission & Vision</strong><br />
                    IBIZ Technova aims to build <strong>1 million digital solutions</strong> tailored for <strong>Industry 4.0</strong> and <strong>Industry 5.0</strong>, focusing on <strong>scalability</strong>, <strong>sustainability</strong>, and <strong>innovation</strong>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
      <Footer />
    </>
  )
}

export default AboutUs
